/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './sw-cms-block-dvsn-form-builder.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-dvsn-form-builder', {
    template,
});
